import { createApiClient, createApi, type Api } from '@cmms/api-client'
import { useAuthStore } from '../store/authStore'
import { useCustomerStore } from '../store/customerStore'

export const baseUrl = import.meta.env.VITE_API_BASE_URL || ''

const client = createApiClient({
  baseUrl,
  getAccessToken: () => useAuthStore.getState().accessToken,
  getRefreshToken: () => useAuthStore.getState().refreshToken,
  onTokenRefresh: (access, refresh) => {
    useAuthStore.getState().setTokens(access, refresh)
  },
  onAuthError: () => {
    useAuthStore.getState().clear()
  },
  // Active customer context — null = consolidated (All), uuid = scoped
  // to that one customer. Read live from the store so the next request
  // picks up the new value the instant the user flips the switcher.
  getCustomerId: () => useCustomerStore.getState().customerId,
})

export const api: Api = createApi(client)

// Raw axios instance — for endpoints that don't (yet) have a typed
// wrapper in the vendored @cmms/api-client dist (a prebuilt copy, not
// a live workspace package we can regenerate from). Same auth/customer
// context as everything under `api.*` since it's the same instance.
export const apiClient = client
